import Alert from './scripts/alert';
import Button from './scripts/button';
import Carousel from './scripts/carousel';
import Collapse from './scripts/collapse';
import Dropdown from './scripts/dropdown';
import Modal from './scripts/modal';
import Offcanvas from './scripts/offcanvas';
import Popover from './scripts/popover';
import Tab from './scripts/tab';
import Scrollspy from './scripts/scrollspy';
import Toast from './scripts/toast';
import Tooltip from './scripts/tooltip';

export default {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  Offcanvas,
  Popover,
  Scrollspy,
  Tab,
  Toast,
  Tooltip,
};
